import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { PageRoutes } from "../../../constants/routes";
import { ErrorMessageManager } from "../../../core/http/ErrorMessageManager";
import { appActions } from "../../../ducks/app";
import { TwilioChannelType } from "../../../ducks/external";
import { useNavigation } from "../../../hooks/useNavigation";
import { useTwilio } from "../../../hooks/useTwilio";

export const useCustomerInfoAuth = () => {
  const dispatch = useDispatch();
  const { navigateToPage } = useNavigation();

  const { checkTwilioCode } = useTwilio();

  const { type, value } = useParams<{ type: string; value: string }>();
  const { state } = useLocation();
  const { key } = state ?? {};

  const handleCustomerInfoAuth = useCallback(
    (code: string) => {
      dispatch(appActions.showLoading());

      checkTwilioCode(
        code,
        type === "email" ? TwilioChannelType.Email : TwilioChannelType.Sms,
        value ?? "",
        () =>
          navigateToPage(PageRoutes.REGISTRATION.replace(":key", key), false, {
            type,
            value,
          }),
        () => {
          dispatch(appActions.hideLoading());
          dispatch(
            appActions.showModal.started({
              title: ErrorMessageManager.Instance.getErrorMessage("AUTH-9002"),
              nextButtonLabel: "閉じる",
              handleNext: () => dispatch(appActions.closeModal()),
            }),
          );
        },
      );
    },
    [type, value, checkTwilioCode],
  );

  const backToRegistration = useCallback(() => {
    navigateToPage(PageRoutes.CUSTOMER_INFO);
  }, []);

  return { handleCustomerInfoAuth, backToRegistration };
};
